/**
 * Created by Bob.Gear on 3/05/14.
 */
//------------------------------------------------------------------------
//  industrySectorFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('projectStatusesFilterController', ['$scope', 'lookupTables',
      function ($scope, lookupTables) {
        $scope.componentName = "projectStatusesFilter";

        $scope.projectStatuses = lookupTables.projectStatuses();

        $scope.resetFilter = function () {
          $scope.clearProjectStageSelections();
        };

        $scope.clearProjectStageSelections = function () {
          $scope.criteria.selectedProjectStatuses = null;
          delete $scope.criteria["selectedProjectStatuses"];
        };

        $scope.removeProjectStatusesFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#projectStatusesFilter");
        };

        $scope.$watch("criteria.selectedProjectStatuses.length", function () {
          if (!$scope.criteria.selectedProjectStatuses) return;

          $scope.selectedCount = $scope.criteria.selectedProjectStatuses.length;
          $scope.plural = ($scope.selectedCount === 1) ? "" : "es";
        });
      }])
    .directive('projectStatusesFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/projectStatusesFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
          },

          controller: 'projectStatusesFilterController'
        };
      }]);
//------------------------------------------------------------------------
